import { useMutation, useQueryClient } from '@tanstack/react-query'
import { WorkspaceObject } from '../../features/workspaces/types'
import { getQueryKey } from '../../services'
import { handleHttpErrors } from '../../shared'
import { getApiClient } from '../../stores'

type CreateWorkspaceParams = {
  onSuccess?: (createdWorkspace: WorkspaceObject) => void
  onError?: (error: Error) => void
} & Parameters<ReturnType<typeof getApiClient>['createWorkspace']>['0']

export function useCreateWorkspace() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ name }: CreateWorkspaceParams) => {
      return await getApiClient().createWorkspace({ name }).catch(handleHttpErrors)
    },
    onSuccess: async (createdWorkspace, { onSuccess }) => {
      await queryClient.invalidateQueries({ queryKey: getQueryKey('workspaces_') })

      onSuccess?.(createdWorkspace)
    },
    onError: (error: Error, { onError }) => {
      onError?.(error)
    },
    meta: { suppressError: true },
  })
}
